<div [formGroup]="formControl">
  <!-- "template" input -->
  <ng-template #input let-field="field">
    <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
        <input matInput
               formControlName="value"
               matTooltip="Mettre précisémment ce que vous souhaitez filtrer (minuscule/majuscules, texte entier, ...)"
               [placeholder]="field.options_obj.label"
               [type]="field.options_obj.controlType">
    </mat-form-field>
  </ng-template>

  <div [ngSwitch]="field.options_obj.controlType">
    <div *ngSwitchCase="fieldType.TypeText"
         fxFlex="90"
         class="field__box" fxLayout="column">
      <ng-container *ngTemplateOutlet="input; context: {'field': field}"></ng-container>
    </div>

    <div *ngSwitchCase="fieldType.TypePhone"
         fxFlex="90"
         class="field__box" fxLayout="column">
      <ng-container *ngTemplateOutlet="input; context: {'field': field}"></ng-container>
    </div>

    <div *ngSwitchCase="fieldType.TypeEmail"
         fxFlex="90"
         class="field__box" fxLayout="column">
      <ng-container *ngTemplateOutlet="input; context: {'field': field}"></ng-container>
    </div>

    <div *ngSwitchCase="fieldType.TypeSelect"
         fxFlex="90"
         class="field__box" fxLayout="column">
      <mat-select
        formControlName="value"
        [placeholder]="field.options_obj.label" [attr.data-cy]="'select-filter-type-value-1-'+value">
        <mat-option *ngFor="let option of field.options_obj.options" [value]="option.key" [attr.data-cy]="'option-filter-type-value-select-'+option.id">
          {{option.key}}
        </mat-option>
      </mat-select>
    </div>

    <div *ngSwitchCase="fieldType.TypeCheckbox"
         fxFlex="90"
         class="field__box" fxLayout="column">
      <mat-select
        formControlName="value"
        [placeholder]="field.options_obj.label" [attr.data-cy]="'select-filter-type-value-2-'+value">
        <mat-option *ngFor="let option of field.options_obj.options" [value]="option.key" [attr.data-cy]="'option-filter-type-value-checkbox-'+option.id">
          {{option.key}}
        </mat-option>
      </mat-select>
    </div>

    <div *ngSwitchCase="fieldType.TypeRadio"
         fxFlex="90"
         class="field__box" fxLayout="column">
      <mat-select
        formControlName="value"
        [placeholder]="field.options_obj.label" [attr.data-cy]="'select-filter-type-value-3-'+value">
        <mat-option *ngFor="let option of field.options_obj.options" [value]="option.key" [attr.data-cy]="'option-filter-type-value-radio-'+option.id">
          {{option.key}}
        </mat-option>
      </mat-select>
    </div>

    <div *ngSwitchCase="fieldType.TypeDate"
         fxFlex="90"
         class="field__box" fxLayout="column">
      <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
        <input
          formControlName="value"
          [placeholder]="field.options_obj.label"
          [matDatepicker]="picker"
          matInput>
        <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>

    <div *ngSwitchCase="fieldType.TypeSvcCmp"
         fxFlex="90"
         class="field__box" fxLayout="column">
      <mat-select
        formControlName="value"
        [placeholder]="field.options_obj.label"
        [attr.data-cy]="'select-filter-type-value-'+value">
        <mat-option *ngFor="let entite of listSvcCmp" [value]="entite" [attr.data-cy]="'option-filter-type'+entite.id">
          {{entite.entite_obj.name}}
        </mat-option>
      </mat-select>
    </div>
  </div>
</div>
